<!-- <div class="search-container">
  <div class="input-group">
    <i class="icon-search"></i>
    <input type="text" class="form-control" [(ngModel)]="searchText" (ngModelChange)="onSearchChange($event)"
      placeholder="{{'Search' | translate}}..." aria-label="Search" />
    <button *ngIf="searchText" class="btn" type="button" (click)="clearSearch()">
      X
    </button>
  </div>
</div> -->


<div class="search-box">
  <i class="icon-search"></i>
  <input type="text" placeholder="Search" class="search-input" />
</div>
<!-- (input)="filterRequests()"
[(ngModel)]="searchTerm" -->
